import { GET_MEMBER_REQUEST } from '../../constants/redux';

export const getMembers = (queryData) => {
  return {
    type: GET_MEMBER_REQUEST,
    payload: queryData
  };
};
